import { FormattedText, ImageComponent, SpanTag } from "@tm/static";
import { theme } from "@tm/utility/global";
import React from "react";

import { ORDER_DETAIL_V2_URLS } from "../../constants";
import {
  BreadcrumbBar,
  BreadcrumbSep,
  BreadcrumbText,
  Container,
  FormattedTextWrapper,
  Hero,
  HeroHeader,
  HeroImageWrapper,
  HeroTitle,
  HeroTitleWrap,
} from "../../OrderDetailV2.style";
import type { OrderDetailV2HeroProps } from "../../types";

export const OrderDetailV2Hero: React.FC<OrderDetailV2HeroProps> = ({
  bookingId,
  title,
  orderIdLabel,
  icon,
  bgColor,
  showNav,
}: OrderDetailV2HeroProps) => {
  return (
    <Hero bgColor={bgColor}>
      <Container>
        <HeroHeader>
          <HeroTitleWrap>
            {showNav && (
              <BreadcrumbBar>
                <BreadcrumbText
                  as="a"
                  href={ORDER_DETAIL_V2_URLS.MY_TRIPS}
                  style={{ textDecoration: "none", cursor: "pointer" }}
                >
                  My Trips
                </BreadcrumbText>
                <BreadcrumbSep>&gt;</BreadcrumbSep>
                <BreadcrumbText>Insurance</BreadcrumbText>
              </BreadcrumbBar>
            )}

            <HeroTitle>
              <SpanTag
                fontSize="xlarge"
                fontWeight="black"
                color={theme.blackText}
              >
                {title || "Your Trip Is Secured!"}
              </SpanTag>
              <SpanTag fontSize="xs" color={theme.greyText7}>
                <FormattedTextWrapper>
                  <FormattedText
                    value={{ html: orderIdLabel }}
                    baseStyle={{}}
                  />
                </FormattedTextWrapper>
              </SpanTag>
            </HeroTitle>
          </HeroTitleWrap>
          {icon && (
            <HeroImageWrapper>
              <ImageComponent src={icon} width="440px" height="160px" />
            </HeroImageWrapper>
          )}
        </HeroHeader>
      </Container>
    </Hero>
  );
};
